import axiosInstance from "./axios";

const get = (url) => axiosInstance.get(url);

export default get;
